import React,  { useState } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import { format } from "date-fns";
import LoadingSpinner from "../../Components/spinner";
import { respondAFeedback } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "sonner";

const FeedbackRespondModal = ({
  showRespondModal,
  setShowRespondModal,
  selectedData,
  setSelectedData,
  pagination,
  fetchFeedbacks,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const feedBackValidations = Yup.object().shape({
    subject: Yup.string().trim().required("subject is required"),
    message: Yup.string().trim().required("message is required"),
  });
  const handleCloseDetailsModal = () => {
    setSelectedData({});
    setShowRespondModal(false);
  };
  const handleFormSubmition = async (subject, message) => {
    const data = {
      subject: subject,
      message: message,
      name: `${selectedData.first_name || ""} ${selectedData.last_name || ""}`,
      feedback_id: selectedData.id,
      email_address: selectedData.email_address,
    };

    const res = await respondAFeedback(data);
    if (res?.data?.success) {
      fetchFeedbacks(pagination);
      toast.success("Feedback has been responded!", { duration: 2000 });
      handleCloseDetailsModal();
    } else {
      handleErrors(res, navigate, "Respond Feedback:");
    }
  };
  return (
    <Modal
      show={showRespondModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Respond Trouble Ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          <Col xs={12} md={6} lg={6} className="mb-3">
            <h4 className="text-light mt-2 mb-2">Trouble Ticket Details</h4>
            {Object.entries({
              Name: `${selectedData.first_name || ""} ${selectedData.last_name || ""}`,
              Email: selectedData.email_address || "",
              "User ID": selectedData.user_id || "",
              Category: selectedData.category || "",
              Feedback: selectedData.message || "",
              Date:
                selectedData?.createdAt &&
                format(selectedData?.createdAt, "PP"),
            }).map(([key, value]) => (
              <div key={key} className="mt-2">
                <strong className="text-blue-500">{key} : </strong>
                <span className="text-light">{value || "N/A"}</span>
              </div>
            ))}
          </Col>
          <Col xs={12} md={6} lg={6} className="mb-3">
            <h4 className="text-light mt-2 mb-2">Response</h4>
            <Formik
              initialValues={{
                subject: "",
                message: "",
              }}
              validationSchema={feedBackValidations}
              onSubmit={async (values) => {
                try {
                  setLoading(true);
                  await handleFormSubmition(values.subject, values.message);
                } catch (error) {
                  console.log("Error upon Responding feedback", error);
                } finally {
                  setLoading(false);
                }
              }}
            >
              {({
                handleChange,
                handleSubmit,
                values,
                errors,
                touched,
              }) => (
                <div>
                  <div className="col-lg-12 text-light">
                    <Form.Group className="mb-2">
                      <Form.Label>Subject</Form.Label>
                      <Form.Control
                        id="subject"
                        name="subject"
                        value={values.subject}
                        onChange={handleChange("subject")}
                        placeholder="Enter Subject"
                        className="bg-dark text-light border-light"
                      />
                      {errors?.subject && touched?.subject ? (
                        <span className="text-danger">{errors?.subject}</span>
                      ) : null}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12 text-light">
                    <Form.Group className="mb-2">
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        id="message"
                        name="message"
                        value={values.message}
                        onChange={handleChange("message")}
                        placeholder="Enter Message"
                        className="bg-dark text-light border-light"
                      />
                      {errors?.message && touched?.message ? (
                        <span className="text-danger">{errors?.message}</span>
                      ) : null}
                    </Form.Group>
                  </div>
                  <div className="constainer-fluid">
                    <div className="d-flex justify-content-end">
                      {loading && (
                        <div className="mt-4 mx-2">
                          <LoadingSpinner size={"lg"} />
                        </div>
                      )}
                      <Button
                        variant="success"
                        className="mt-3"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Respond
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackRespondModal;
